const upload = document.getElementById('upload');
const uploadSection = document.getElementById('uploadSection');
const canvas = document.getElementById('canvas');
const ctx = canvas.getContext('2d');
const downloadBtn = document.getElementById('download');
const colorInput = document.getElementById('color');
const toleranceInput = document.getElementById('tolerance');
const tolval = document.getElementById('tolval');
const controls = document.getElementById('controls');
const clarityInput = document.getElementById('clarity');
const clarval = document.getElementById('clarval');
const dehazeInput = document.getElementById('dehaze');
const dehazeval = document.getElementById('dehazeval');
const applyBtn = document.getElementById('applyBtn');
const resetBtn = document.getElementById('resetBtn');
const keepSatInput = document.getElementById('keepSat');
const keepSatVal = document.getElementById('keepSatVal');
const keepHueInput = document.getElementById('keepHue');
const keepHueVal = document.getElementById('keepHueVal');
const keepLightnessInput = document.getElementById('keepLightness');
const keepLightnessVal = document.getElementById('keepLightnessVal');
const keepBrightnessInput = document.getElementById('keepBrightness');
const keepBrightnessVal = document.getElementById('keepBrightnessVal');
const vignetteInput = document.getElementById('vignette');
const vignetteval = document.getElementById('vignetteval');
const vignetteNum = document.getElementById('vignetteNum');
const clarityStrengthInput = document.getElementById('clarityStrength');
const clarityStrengthVal = document.getElementById('clarityStrengthVal');
const clarityStrengthNum = document.getElementById('clarityStrengthNum');
const clarityContrastInput = document.getElementById('clarityContrast');
const clarityContrastVal = document.getElementById('clarityContrastVal');
const clarityContrastNum = document.getElementById('clarityContrastNum');
const dehazeContrastInput = document.getElementById('dehazeContrast');
const dehazeContrastVal = document.getElementById('dehazeContrastVal');
const dehazeContrastNum = document.getElementById('dehazeContrastNum');
const dehazeBrightnessInput = document.getElementById('dehazeBrightness');
const dehazeBrightnessVal = document.getElementById('dehazeBrightnessVal');
const dehazeBrightnessNum = document.getElementById('dehazeBrightnessNum');
const vignetteStrengthInput = document.getElementById('vignetteStrength');
const vignetteStrengthVal = document.getElementById('vignetteStrengthVal');
const vignetteStrengthNum = document.getElementById('vignetteStrengthNum');
const toleranceNum = document.getElementById('toleranceNum');
const clarityNum = document.getElementById('clarityNum');
const dehazeNum = document.getElementById('dehazeNum');
const keepSatNum = document.getElementById('keepSatNum');
const keepHueNum = document.getElementById('keepHueNum');
const keepLightnessNum = document.getElementById('keepLightnessNum');
const keepBrightnessNum = document.getElementById('keepBrightnessNum');
const loader = document.getElementById('loader');
const canvasOverlay = document.getElementById('canvasOverlay');
const stats = document.getElementById('stats');
const imageSizeEl = document.getElementById('imageSize');
const processingTimeEl = document.getElementById('processingTime');
const pixelsProcessedEl = document.getElementById('pixelsProcessed');
const autoApply = document.getElementById('autoApply');
const temperatureInput = document.getElementById('temperature');
const temperatureVal = document.getElementById('temperatureVal');
const temperatureNum = document.getElementById('temperatureNum');
const savePresetBtn = document.getElementById('savePresetBtn');
const savePresetModal = document.getElementById('savePresetModal');
const presetNameInput = document.getElementById('presetNameInput');
const confirmSavePreset = document.getElementById('confirmSavePreset');
const cancelSavePreset = document.getElementById('cancelSavePreset');
const customPresetsSection = document.getElementById('customPresetsSection');
const customPresetsGrid = document.getElementById('customPresetsGrid');
const mainActionRow = document.getElementById('mainActionRow');
const uploadContainer = document.getElementById('uploadContainer');
const step1 = document.getElementById('step1');
const step2 = document.getElementById('step2');
const importBox = document.getElementById('importBox');

let imgData = null;
let originalImgData = null;
let startTime = 0;
let applyTimeout = null;

function debouncedApply() {
  clearTimeout(applyTimeout);
  applyTimeout = setTimeout(() => {
    if (imgData) applyColorSplash();
  }, 150); // 150ms delay
}

// Preset configurations
const presets = {
  blue: { color: '#0000ff', tolerance: 30, clarity: 10, clarityStrength: 1.50, clarityContrast: 1.20, dehaze: 10, dehazeContrast: 1.15, dehazeBrightness: 10, vignette: 15, vignetteStrength: 0.5, saturation: 1.4, hue: 0, lightness: 0, brightness: 0, temperature: -20 },
  red: { color: '#ff0000', tolerance: 30, clarity: 15, clarityStrength: 1.50, clarityContrast: 1.20, dehaze: 5, dehazeContrast: 1.15, dehazeBrightness: 10, vignette: 20, vignetteStrength: 0.5, saturation: 1.6, hue: 0, lightness: 0, brightness: 0, temperature: 20 },
  green: { color: '#00ff00', tolerance: 25, clarity: 8, clarityStrength: 1.50, clarityContrast: 1.20, dehaze: 15, dehazeContrast: 1.15, dehazeBrightness: 10, vignette: 10, vignetteStrength: 0.5, saturation: 1.3, hue: 0, lightness: 0, brightness: 0, temperature: 0 },
  yellow: { color: '#ffff00', tolerance: 35, clarity: 12, clarityStrength: 1.50, clarityContrast: 1.20, dehaze: 8, dehazeContrast: 1.15, dehazeBrightness: 10, vignette: 25, vignetteStrength: 0.5, saturation: 1.5, hue: 0, lightness: 0, brightness: 0, temperature: 15 },
  purple: { color: '#800080', tolerance: 28, clarity: 18, clarityStrength: 1.50, clarityContrast: 1.20, dehaze: 12, dehazeContrast: 1.15, dehazeBrightness: 10, vignette: 30, vignetteStrength: 0.5, saturation: 1.7, hue: 0, lightness: 0, brightness: 0, temperature: -10 },
  orange: { color: '#ffa500', tolerance: 32, clarity: 14, clarityStrength: 1.50, clarityContrast: 1.20, dehaze: 6, dehazeContrast: 1.15, dehazeBrightness: 10, vignette: 18, vignetteStrength: 0.5, saturation: 1.4, hue: 0, lightness: 0, brightness: 0, temperature: 25 },
  pink: { color: '#ffc0cb', tolerance: 30, clarity: 16, clarityStrength: 1.50, clarityContrast: 1.20, dehaze: 10, dehazeContrast: 1.15, dehazeBrightness: 10, vignette: 22, vignetteStrength: 0.5, saturation: 1.6, hue: 0, lightness: 0, brightness: 0, temperature: 10 },
  teal: { color: '#008080', tolerance: 26, clarity: 9, clarityStrength: 1.50, clarityContrast: 1.20, dehaze: 18, dehazeContrast: 1.15, dehazeBrightness: 10, vignette: 12, vignetteStrength: 0.5, saturation: 1.3, hue: 0, lightness: 0, brightness: 0, temperature: -15 }
};

// Custom presets management
let customPresets = JSON.parse(localStorage.getItem('customPresets') || '{}');

function saveCustomPreset(name) {
  const currentSettings = {
    hue: parseInt(hueSlider.value),
    tolerance: parseInt(toleranceInput.value),
    clarity: parseInt(clarityInput.value),
    clarityStrength: parseFloat(clarityStrengthInput.value),
    clarityContrast: parseFloat(clarityContrastInput.value),
    dehaze: parseInt(dehazeInput.value),
    dehazeContrast: parseFloat(dehazeContrastInput.value),
    dehazeBrightness: parseInt(dehazeBrightnessInput.value),
    vignette: parseInt(vignetteInput.value),
    vignetteStrength: parseFloat(vignetteStrengthInput.value),
    saturation: parseFloat(keepSatInput.value),
    hueShift: parseFloat(keepHueInput.value),
    lightness: parseFloat(keepLightnessInput.value),
    brightness: parseFloat(keepBrightnessInput.value),
    temperature: parseFloat(temperatureInput.value)
  };
  
  customPresets[name] = currentSettings;
  localStorage.setItem('customPresets', JSON.stringify(customPresets));
  renderCustomPresets();
}

function loadCustomPreset(name) {
  console.log('[DEBUG] Loading custom preset:', name, customPresets[name]); // DEBUG LOG
  const preset = customPresets[name];
  if (preset) {
    // Set hue slider and recalculate keepColorHex
    if (hueSlider && colorPreview) {
      hueSlider.value = preset.hue !== undefined ? preset.hue : 240;
      if (typeof updateColorFromHue === 'function') updateColorFromHue();
    }
    toleranceInput.value = preset.tolerance;
    toleranceNum.value = preset.tolerance;
    clarityInput.value = preset.clarity;
    clarityNum.value = preset.clarity;
    clarityStrengthInput.value = preset.clarityStrength;
    clarityStrengthNum.value = preset.clarityStrength;
    clarityContrastInput.value = preset.clarityContrast;
    clarityContrastNum.value = preset.clarityContrast;
    dehazeInput.value = preset.dehaze;
    dehazeNum.value = preset.dehaze;
    dehazeContrastInput.value = preset.dehazeContrast;
    dehazeContrastNum.value = preset.dehazeContrast;
    dehazeBrightnessInput.value = preset.dehazeBrightness;
    dehazeBrightnessNum.value = preset.dehazeBrightness;
    vignetteInput.value = preset.vignette;
    vignetteNum.value = preset.vignette;
    vignetteStrengthInput.value = preset.vignetteStrength;
    vignetteStrengthNum.value = preset.vignetteStrength;
    keepSatInput.value = preset.saturation;
    keepSatNum.value = preset.saturation;
    keepHueInput.value = preset.hueShift !== undefined ? preset.hueShift : 0;
    keepHueNum.value = preset.hueShift !== undefined ? preset.hueShift : 0;
    keepLightnessInput.value = preset.lightness;
    keepLightnessNum.value = preset.lightness;
    keepBrightnessInput.value = preset.brightness;
    keepBrightnessNum.value = preset.brightness;
    temperatureInput.value = preset.temperature;
    temperatureNum.value = preset.temperature;
    // Update displays
    tolval.textContent = preset.tolerance;
    clarval.textContent = preset.clarity;
    clarityStrengthVal.textContent = preset.clarityStrength;
    clarityContrastVal.textContent = preset.clarityContrast;
    dehazeval.textContent = preset.dehaze;
    dehazeContrastVal.textContent = preset.dehazeContrast;
    dehazeBrightnessVal.textContent = preset.dehazeBrightness;
    vignetteval.textContent = preset.vignette;
    vignetteStrengthVal.textContent = preset.vignetteStrength;
    keepSatVal.textContent = preset.saturation;
    keepHueVal.textContent = preset.hueShift !== undefined ? preset.hueShift : 0;
    keepLightnessVal.textContent = preset.lightness;
    keepBrightnessVal.textContent = preset.brightness;
    temperatureVal.textContent = preset.temperature;
    // Remove active class from all preset buttons
    document.querySelectorAll('.ie--preset-btn').forEach(b => b.classList.remove('active'));
    if (imgData) {
      debouncedApply();
    }
  }
}

function deleteCustomPreset(name) {
  delete customPresets[name];
  localStorage.setItem('customPresets', JSON.stringify(customPresets));
  renderCustomPresets();
}

function renderCustomPresets() {
  const presetNames = Object.keys(customPresets);
  if (presetNames.length > 0) {
    customPresetsSection.style.display = 'block';
    customPresetsGrid.innerHTML = '';
    
    presetNames.forEach(name => {
      const presetBtn = document.createElement('button');
      presetBtn.className = 'ie--preset-btn';
      presetBtn.textContent = name;
      presetBtn.style.position = 'relative';
      
      const deleteBtn = document.createElement('button');
      deleteBtn.innerHTML = '×';
      deleteBtn.style.cssText = `
        position: absolute;
        top: -5px;
        right: -5px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #ff4444;
        color: white;
        border: none;
        font-size: 12px;
        cursor: pointer;
        display: none;
      `;
      
      presetBtn.appendChild(deleteBtn);
      
      presetBtn.addEventListener('click', () => {
        console.log('[DEBUG] Preset button clicked:', name);
        loadCustomPreset(name);
      });
      deleteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (confirm(`Delete preset "${name}"?`)) {
          deleteCustomPreset(name);
        }
      });
      
      presetBtn.addEventListener('mouseenter', () => deleteBtn.style.display = 'block');
      presetBtn.addEventListener('mouseleave', () => deleteBtn.style.display = 'none');
      
      customPresetsGrid.appendChild(presetBtn);
    });
  } else {
    customPresetsSection.style.display = 'none';
  }
}

// Initialize custom presets
// Add null checks for customPresetsSection, customPresetsGrid, savePresetBtn, savePresetModal, presetNameInput, confirmSavePreset, and cancelSavePreset before accessing their properties or adding event listeners. This will prevent errors if any are missing from the DOM.
if (typeof renderCustomPresets === 'function') {
  if (typeof customPresetsSection !== 'undefined' && customPresetsSection && typeof customPresetsGrid !== 'undefined' && customPresetsGrid) {
    renderCustomPresets();
  }
}
if (typeof savePresetBtn !== 'undefined' && savePresetBtn) {
  savePresetBtn.addEventListener('click', () => {
    if (savePresetModal) {
      savePresetModal.style.display = 'flex';
      if (presetNameInput) presetNameInput.focus();
    }
  });
}
if (typeof cancelSavePreset !== 'undefined' && cancelSavePreset) {
  cancelSavePreset.addEventListener('click', () => {
    if (savePresetModal) savePresetModal.style.display = 'none';
    if (presetNameInput) presetNameInput.value = '';
  });
}
if (typeof confirmSavePreset !== 'undefined' && confirmSavePreset) {
  confirmSavePreset.addEventListener('click', () => {
    if (!presetNameInput) {
      alert("Preset name input not found!");
      return;
    }
    const name = presetNameInput.value.trim();
    if (name) {
      if (typeof saveCustomPreset === 'function') saveCustomPreset(name);
      if (savePresetModal) savePresetModal.style.display = 'none';
      presetNameInput.value = '';
    }
  });
}
if (typeof presetNameInput !== 'undefined' && presetNameInput) {
  presetNameInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter' && confirmSavePreset) {
      confirmSavePreset.click();
    }
  });
}
if (typeof savePresetModal !== 'undefined' && savePresetModal) {
  savePresetModal.addEventListener('click', (e) => {
    if (e.target === savePresetModal) {
      savePresetModal.style.display = 'none';
      if (presetNameInput) presetNameInput.value = '';
    }
  });
}

// Tab navigation
document.querySelectorAll('.ie--nav-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    document.querySelectorAll('.ie--nav-tab').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
  });
});

// Preset buttons
document.querySelectorAll('.ie--preset-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const preset = presets[btn.dataset.preset];
    if (preset) {
      colorInput.value = preset.color;
      toleranceInput.value = preset.tolerance;
      toleranceNum.value = preset.tolerance;
      clarityInput.value = preset.clarity;
      clarityNum.value = preset.clarity;
      clarityStrengthInput.value = preset.clarityStrength;
      clarityStrengthNum.value = preset.clarityStrength;
      clarityContrastInput.value = preset.clarityContrast;
      clarityContrastNum.value = preset.clarityContrast;
      dehazeInput.value = preset.dehaze;
      dehazeNum.value = preset.dehaze;
      dehazeContrastInput.value = preset.dehazeContrast;
      dehazeContrastNum.value = preset.dehazeContrast;
      dehazeBrightnessInput.value = preset.dehazeBrightness;
      dehazeBrightnessNum.value = preset.dehazeBrightness;
      keepSatInput.value = preset.saturation;
      keepSatNum.value = preset.saturation;
      keepHueInput.value = preset.hue;
      keepHueNum.value = preset.hue;
      keepLightnessInput.value = preset.lightness;
      keepLightnessNum.value = preset.lightness;
      keepBrightnessInput.value = preset.brightness;
      keepBrightnessNum.value = preset.brightness;
      vignetteInput.value = preset.vignette;
      vignetteNum.value = preset.vignette;
      vignetteStrengthInput.value = preset.vignetteStrength;
      vignetteStrengthNum.value = preset.vignetteStrength;
      temperatureInput.value = preset.temperature;
      temperatureNum.value = preset.temperature;
      
      // Update displays
      tolval.textContent = preset.tolerance;
      clarval.textContent = preset.clarity;
      clarityStrengthVal.textContent = preset.clarityStrength;
      clarityContrastVal.textContent = preset.clarityContrast;
      dehazeval.textContent = preset.dehaze;
      dehazeContrastVal.textContent = preset.dehazeContrast;
      dehazeBrightnessVal.textContent = preset.dehazeBrightness;
      vignetteval.textContent = preset.vignette;
      vignetteStrengthVal.textContent = preset.vignetteStrength;
      keepSatVal.textContent = preset.saturation;
      keepHueVal.textContent = preset.hue;
      keepLightnessVal.textContent = preset.lightness;
      keepBrightnessVal.textContent = preset.brightness;
      temperatureVal.textContent = preset.temperature;
      
      // Remove active class from all preset buttons
      document.querySelectorAll('.ie--preset-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      
      if (imgData) {
        debouncedApply();
      }
    }
  });
});

// Drag and drop functionality
if (importBox) {
  importBox.addEventListener('dragover', (e) => {
    e.preventDefault();
    importBox.classList.add('dragover');
  });
  importBox.addEventListener('dragleave', () => {
    importBox.classList.remove('dragover');
  });
  importBox.addEventListener('drop', (e) => {
    e.preventDefault();
    importBox.classList.remove('dragover');
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      upload.files = files;
      handleFileSelect(files[0]);
    }
  });
} else if (uploadSection) {
  uploadSection.addEventListener('dragover', (e) => {
    e.preventDefault();
    uploadSection.classList.add('dragover');
  });
  uploadSection.addEventListener('dragleave', () => {
    uploadSection.classList.remove('dragover');
  });
  uploadSection.addEventListener('drop', (e) => {
    e.preventDefault();
    uploadSection.classList.remove('dragover');
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      upload.files = files;
      handleFileSelect(files[0]);
    }
  });
}

function rgbToHsv(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  let max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s, v = max;
  let d = max - min;
  s = max === 0 ? 0 : d / max;
  if (max === min) {
    h = 0;
  } else {
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }
  return [h * 360, s, v];
}

function hexToRgb(hex) {
  hex = hex.replace('#', '');
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;
  return [r, g, b];
}

function applyClarity(imageData, amount, strength = 1.0, contrast = 1.0) {
  if (amount === 0) return imageData;
  const w = imageData.width, h = imageData.height;
  const src = imageData.data;
  const blur = new Uint8ClampedArray(src.length);
  for (let y = 1; y < h - 1; y++) {
    for (let x = 1; x < w - 1; x++) {
      for (let c = 0; c < 3; c++) {
        let sum = 0;
        for (let ky = -1; ky <= 1; ky++) {
          for (let kx = -1; kx <= 1; kx++) {
            let ni = ((y + ky) * w + (x + kx)) * 4 + c;
            sum += src[ni];
          }
        }
        blur[(y * w + x) * 4 + c] = sum / 9;
      }
      blur[(y * w + x) * 4 + 3] = src[(y * w + x) * 4 + 3];
    }
  }
  const out = new Uint8ClampedArray(src.length);
  for (let i = 0; i < src.length; i += 4) {
    let luma = 0.299 * src[i] + 0.587 * src[i+1] + 0.114 * src[i+2];
    let blend = (luma > 40 && luma < 200) ? (amount / 100) * strength : 0;
    for (let c = 0; c < 3; c++) {
      let highpass = src[i + c] - blur[i + c] + 128;
      let pixel = src[i + c] + blend * (highpass - 128);
      // Apply contrast after clarity
      pixel = ((pixel - 128) * contrast) + 128;
      out[i + c] = Math.min(255, Math.max(0, pixel));
    }
    out[i + 3] = src[i + 3];
  }
  return new ImageData(out, w, h);
}

function applyDehaze(imageData, amount, contrast = 1.0, brightness = 0) {
  if (amount === 0) return imageData;
  const w = imageData.width, h = imageData.height;
  const src = imageData.data;
  const dark = new Float32Array((w * h));
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      let minVal = 255;
      for (let ky = -3; ky <= 3; ky++) {
        for (let kx = -3; kx <= 3; kx++) {
          let nx = Math.min(w-1, Math.max(0, x + kx));
          let ny = Math.min(h-1, Math.max(0, y + ky));
          let ni = (ny * w + nx) * 4;
          minVal = Math.min(minVal, src[ni], src[ni+1], src[ni+2]);
        }
      }
      dark[y * w + x] = minVal;
    }
  }
  const out = new Uint8ClampedArray(src.length);
  let scale = amount / 100 * 0.95;
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      let i = (y * w + x) * 4;
      let haze = dark[y * w + x] * scale;
      for (let c = 0; c < 3; c++) {
        let pixel = src[i + c] - haze;
        // Apply contrast
        pixel = ((pixel - 128) * contrast) + 128;
        // Apply brightness
        pixel += brightness;
        out[i + c] = Math.min(255, Math.max(0, pixel));
      }
      out[i + 3] = src[i + 3];
    }
  }
  return new ImageData(out, w, h);
}

function applyVignette(imageData, amount, strength = 1.0) {
  if (amount === 0) return imageData;
  const w = imageData.width, h = imageData.height;
  const src = imageData.data;
  const out = new Uint8ClampedArray(src.length);
  const centerX = w / 2;
  const centerY = h / 2;
  const maxDistance = Math.sqrt(centerX * centerX + centerY * centerY);
  
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const i = (y * w + x) * 4;
      const distance = Math.sqrt((x - centerX) * (x - centerX) + (y - centerY) * (y - centerY));
      const vignetteFactor = 1 - (distance / maxDistance) * (amount / 100) * strength;
      
      for (let c = 0; c < 3; c++) {
        out[i + c] = Math.min(255, Math.max(0, src[i + c] * vignetteFactor));
      }
      out[i + 3] = src[i + 3];
    }
  }
  return new ImageData(out, w, h);
}

// Helper: get color family hue range
function getColorFamilyRange(hue) {
  // Returns [min, max] for the color family (hue in degrees)
  if (hue >= 200 && hue <= 260) return [200, 260]; // blue
  if ((hue >= 340 && hue <= 360) || (hue >= 0 && hue <= 20)) return [340, 20]; // red (wraps around)
  if (hue >= 80 && hue <= 160) return [80, 160]; // green
  if (hue >= 40 && hue <= 70) return [40, 70]; // yellow
  if (hue >= 20 && hue < 40) return [20, 39]; // orange
  if (hue >= 260 && hue <= 290) return [260, 290]; // purple
  if (hue >= 290 && hue < 340) return [291, 339]; // pink
  if (hue >= 161 && hue < 200) return [161, 199]; // teal/cyan
  return [hue - 15, hue + 15]; // fallback: ±15°
}

function isHueInRange(h, min, max) {
  if (min <= max) return h >= min && h <= max;
  // wrap-around (e.g., red: 340–20)
  return h >= min || h <= max;
}

// --- Color Picker Logic ---
function hsvToHex(h, s, v) {
  let f = (n, k = (n + h / 60) % 6) => v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  let r = Math.round(f(5) * 255), g = Math.round(f(3) * 255), b = Math.round(f(1) * 255);
  return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
}
const hueSlider = document.getElementById('hueSlider');
const colorPreview = document.getElementById('colorPreview');
let keepColorHex = '#0000ff';
if (hueSlider && colorPreview) {
  function updateColorFromHue() {
    const h = parseInt(hueSlider.value);
    keepColorHex = hsvToHex(h, 1, 1);
    colorPreview.style.background = keepColorHex;
    // Dynamically update the slider thumb color for all browsers
    hueSlider.style.setProperty('--hue-thumb', keepColorHex);
    // If you use a hidden color input for compatibility, update its value too
    // colorInput.value = keepColorHex;
    if (imgData) debouncedApply();
  }
  hueSlider.addEventListener('input', updateColorFromHue);
  updateColorFromHue();
}

function applyColorSplash() {
  if (!imgData) return;
  
  startTime = performance.now();
  canvasOverlay.style.display = 'block';
  
  let imageData = ctx.createImageData(imgData.width, imgData.height);
  let data = imageData.data;
  let orig = imgData.data;
  // Use keepColorHex instead of colorInput.value
  let [targetR, targetG, targetB] = hexToRgb(keepColorHex);
  let [targetH, targetS, targetV] = rgbToHsv(targetR, targetG, targetB);
  let [hueMin, hueMax] = getColorFamilyRange(targetH);
  let tol = parseInt(toleranceInput.value);
  let keepSat = parseFloat(keepSatInput.value);
  let keepHue = parseFloat(keepHueInput.value);
  let keepLightness = parseFloat(keepLightnessInput.value);
  let keepBrightness = parseFloat(keepBrightnessInput.value);
  let vignetteVal = parseInt(vignetteInput.value);

  // Tone tolerances (for now, hardcoded)
  const satTol = 0.25; // ±25% saturation
  const valTol = 0.25; // ±25% value/brightness

  let pixelsProcessed = 0;
  
  for (let i = 0; i < orig.length; i += 4) {
    let r = orig[i], g = orig[i+1], b = orig[i+2];
    let [h, s, v] = rgbToHsv(r, g, b);
    // Use color family range only
    if (isHueInRange(h, hueMin, hueMax)) {
      let newS = Math.min(1, s * keepSat);
      let newV = Math.min(1, v * 1.1);
      let newH = (h + keepHue + 360) % 360;
      
      // Apply lightness adjustment (affects the overall brightness)
      if (keepLightness !== 0) {
        newV = Math.min(1, Math.max(0, newV + (keepLightness / 100)));
      }
      
      // Apply brightness adjustment (affects all RGB channels)
      let brightnessMultiplier = 1 + (keepBrightness / 100);
      
      let c = newV * newS;
      let x = c * (1 - Math.abs(((newH / 60) % 2) - 1));
      let m = newV - c;
      let r1, g1, b1;
      if (newH < 60) { r1 = c; g1 = x; b1 = 0; }
      else if (newH < 120) { r1 = x; g1 = c; b1 = 0; }
      else if (newH < 180) { r1 = 0; g1 = c; b1 = x; }
      else if (newH < 240) { r1 = 0; g1 = x; b1 = c; }
      else if (newH < 300) { r1 = x; g1 = 0; b1 = c; }
      else { r1 = c; g1 = 0; b1 = x; }
      
      // Apply brightness multiplier
      r1 = Math.min(1, r1 * brightnessMultiplier);
      g1 = Math.min(1, g1 * brightnessMultiplier);
      b1 = Math.min(1, b1 * brightnessMultiplier);
      m = Math.min(1, m * brightnessMultiplier);
      
      data[i] = Math.round((r1 + m) * 255);
      data[i+1] = Math.round((g1 + m) * 255);
      data[i+2] = Math.round((b1 + m) * 255);
    } else {
      let avg = 0.299 * r + 0.587 * g + 0.114 * b;
      data[i] = data[i+1] = data[i+2] = avg;
    }
    data[i+3] = orig[i+3];
    pixelsProcessed++;
  }
  
  let clarityVal = parseInt(clarityInput.value);
  let clarityStrengthVal = parseFloat(clarityStrengthInput.value);
  let clarityContrastVal = parseFloat(clarityContrastInput.value);
  if (clarityVal !== 0) {
    imageData = applyClarity(imageData, clarityVal, clarityStrengthVal, clarityContrastVal);
  }
  
  let dehazeVal = parseInt(dehazeInput.value);
  let dehazeContrastVal = parseFloat(dehazeContrastInput.value);
  let dehazeBrightnessVal = parseInt(dehazeBrightnessInput.value);
  if (dehazeVal !== 0) {
    imageData = applyDehaze(imageData, dehazeVal, dehazeContrastVal, dehazeBrightnessVal);
  }
  
  let vignetteStrengthVal = parseFloat(vignetteStrengthInput.value);
  if (vignetteVal !== 0) {
    imageData = applyVignette(imageData, vignetteVal, vignetteStrengthVal);
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // Apply temperature adjustment
  let temp = parseFloat(temperatureInput.value);
  if (temp !== 0) {
    let tempData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    let tempPixels = tempData.data;
    let factor = temp / 100;
    
    for (let i = 0; i < tempPixels.length; i += 4) {
      // Warm: increase red, decrease blue
      // Cool: increase blue, decrease red
      tempPixels[i] = Math.min(255, Math.max(0, tempPixels[i] + factor * 20));     // red
      tempPixels[i+2] = Math.min(255, Math.max(0, tempPixels[i+2] - factor * 20)); // blue
    }
    
    ctx.putImageData(tempData, 0, 0);
  }
  
  const endTime = performance.now();
  const processingTime = Math.round(endTime - startTime);
  
  // Update stats
  if (typeof imageSizeEl !== 'undefined' && imageSizeEl) {
    // imageSizeEl is updated elsewhere after file load
  }
  canvasOverlay.style.display = 'none';
}

function setInitialUI() {
  step1.style.display = 'block';
  step2.style.display = 'none';
}

function setImageLoadedUI() {
  step1.style.display = 'none';
  step2.style.display = 'block';
}

setInitialUI();

function resizeImageIfNeeded(img, maxDim = 1440) {
  let { width, height } = img;
  if (width > maxDim || height > maxDim) {
    const scale = maxDim / Math.max(width, height);
    width = Math.round(width * scale);
    height = Math.round(height * scale);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').drawImage(img, 0, 0, width, height);
    return canvas;
  }
  return img;
}

function handleFileSelect(file) {
  if (!file) return;
  const reader = new FileReader();
  reader.onload = function(e) {
    const img = new Image();
    img.onload = function() {
      // Resize if needed
      let displayImg = img;
      let wasResized = false;
      let origW = img.width, origH = img.height;
      let optW = img.width, optH = img.height;
      if (img.width > 1440 || img.height > 1440) {
        displayImg = resizeImageIfNeeded(img, 1440);
        wasResized = true;
        optW = displayImg.width;
        optH = displayImg.height;
      }
      canvas.width = displayImg.width;
      canvas.height = displayImg.height;
      ctx.drawImage(displayImg, 0, 0, displayImg.width, displayImg.height);
      imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      originalImgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      controls.style.display = 'block';
      canvas.style.display = 'block';
      downloadBtn.style.display = 'inline-block';
      // Show both original and optimized size and dimensions
      const originalSizeKB = Math.round(file.size / 1024);
      canvas.toBlob(function(blob) {
        const optimizedSizeKB = Math.round(blob.size / 1024);
        const percentChange = ((optimizedSizeKB-originalSizeKB)/originalSizeKB*100);
        const percentColor = percentChange > 0 ? "#d33" : "#2a7";
        imageSizeEl.innerHTML = `
       
          <table class="ie--image-stats-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Size</th>
                <th>Dimensions</th>
                <th>Change (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Original</td>
                <td>${originalSizeKB} KB</td>
                <td>${origW}x${origH}</td>
                <td>—</td>
              </tr>
              <tr>
                <td style="color:${percentColor};">Optimized</td>
                <td style="color:${percentColor};">${optimizedSizeKB} KB</td>
                <td style="color:${percentColor};">${optW}x${optH}</td>
                <td style="color:${percentColor};">${percentChange.toFixed(1)}%</td>
              </tr>
            </tbody>
          </table>
        `;
      }, 'image/jpeg', 0.92);
      applyColorSplash();
      setImageLoadedUI();
    };
    img.src = e.target.result;
  };
  reader.readAsDataURL(file);
}

upload.addEventListener('change', e => {
  handleFileSelect(e.target.files[0]);
});

// Add auto-apply to color input
// colorInput.addEventListener('input', function() {
//   if (imgData) {
//     debouncedApply();
//   }
// });

// Range and number input sync functions
function syncRangeAndNumber(rangeInput, numberInput, displayElement) {
  rangeInput.addEventListener('input', function() {
    numberInput.value = rangeInput.value;
    displayElement.textContent = rangeInput.value;
    if (imgData) {
      debouncedApply();
    }
  });
  
  numberInput.addEventListener('input', function() {
    rangeInput.value = numberInput.value;
    displayElement.textContent = numberInput.value;
    if (imgData) {
      debouncedApply();
    }
  });
}

// Sync all range and number inputs
syncRangeAndNumber(toleranceInput, toleranceNum, tolval);
syncRangeAndNumber(clarityInput, clarityNum, clarval);
syncRangeAndNumber(clarityStrengthInput, clarityStrengthNum, clarityStrengthVal);
syncRangeAndNumber(clarityContrastInput, clarityContrastNum, clarityContrastVal);
syncRangeAndNumber(dehazeInput, dehazeNum, dehazeval);
syncRangeAndNumber(dehazeContrastInput, dehazeContrastNum, dehazeContrastVal);
syncRangeAndNumber(dehazeBrightnessInput, dehazeBrightnessNum, dehazeBrightnessVal);
syncRangeAndNumber(vignetteInput, vignetteNum, vignetteval);
syncRangeAndNumber(vignetteStrengthInput, vignetteStrengthNum, vignetteStrengthVal);
syncRangeAndNumber(keepSatInput, keepSatNum, keepSatVal);
syncRangeAndNumber(keepHueInput, keepHueNum, keepHueVal);
syncRangeAndNumber(keepLightnessInput, keepLightnessNum, keepLightnessVal);
syncRangeAndNumber(keepBrightnessInput, keepBrightnessNum, keepBrightnessVal);
syncRangeAndNumber(temperatureInput, temperatureNum, temperatureVal);

applyBtn.addEventListener('click', function() {
  loader.style.display = 'flex';
  setTimeout(() => {
    applyColorSplash();
    loader.style.display = 'none';
  }, 30);
});

resetBtn.addEventListener('click', function() {
  if (originalImgData) {
    ctx.putImageData(originalImgData, 0, 0);
    imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    
    // Reset controls to defaults
    // colorInput.value = '#0000ff';
    if (hueSlider && colorPreview) {
      hueSlider.value = 240;
      keepColorHex = hsvToHex(240, 1, 1);
      colorPreview.style.background = keepColorHex;
      hueSlider.style.setProperty('--hue-thumb', keepColorHex);
    }
    toleranceInput.value = 30;
    toleranceNum.value = 30;
    clarityInput.value = 10;
    clarityNum.value = 10;
    clarityStrengthInput.value = 1.50;
    clarityStrengthNum.value = 1.50;
    clarityContrastInput.value = 1.20;
    clarityContrastNum.value = 1.20;
    dehazeInput.value = 10;
    dehazeNum.value = 10;
    dehazeContrastInput.value = 1.15;
    dehazeContrastNum.value = 1.15;
    dehazeBrightnessInput.value = 10;
    dehazeBrightnessNum.value = 10;
    vignetteInput.value = 0;
    vignetteNum.value = 0;
    vignetteStrengthInput.value = 0.5;
    vignetteStrengthNum.value = 0.5;
    keepSatInput.value = 1.4;
    keepSatNum.value = 1.4;
    keepHueInput.value = 0;
    keepHueNum.value = 0;
    keepLightnessInput.value = 0;
    keepLightnessNum.value = 0;
    keepBrightnessInput.value = 0;
    keepBrightnessNum.value = 0;
    temperatureInput.value = 0;
    temperatureNum.value = 0;
    
    // Update displays
    tolval.textContent = '30';
    clarval.textContent = '10';
    clarityStrengthVal.textContent = '1.50';
    clarityContrastVal.textContent = '1.20';
    dehazeval.textContent = '10';
    dehazeContrastVal.textContent = '1.15';
    dehazeBrightnessVal.textContent = '10';
    vignetteval.textContent = '0';
    vignetteStrengthVal.textContent = '0.5';
    keepSatVal.textContent = '1.4';
    keepHueVal.textContent = '0';
    keepLightnessVal.textContent = '0';
    keepBrightnessVal.textContent = '0';
    temperatureVal.textContent = '0';
    
    // Remove active preset
    document.querySelectorAll('.ie--preset-btn').forEach(b => b.classList.remove('active'));
  }
});

downloadBtn.onclick = function() {
  canvas.toBlob(function(blob) {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'image-effect-v3.jpg';
    link.click();
    setTimeout(() => URL.revokeObjectURL(link.href), 1000);
  }, 'image/jpeg', 0.92);
};

// Dynamically update stat table percentage and progress circle
function updateStatTable(originalKB, optimizedKB) {
  const percent = ((originalKB - optimizedKB) / originalKB) * 100;
  const percentText = percent.toFixed(2) + '%';
  const circle = document.querySelector('.ie--stat-circle circle:nth-child(2)');
  const text = document.querySelector('.ie--stat-percent-text');
  const circumference = 2 * Math.PI * 10; // r=10
  const offset = circumference * (1 - percent / 100);
  if (circle) circle.setAttribute('stroke-dashoffset', offset);
  if (text) text.textContent = percentText;
}

document.addEventListener('DOMContentLoaded', function() {
  // Example usage: 466.3KB original, 362.2KB optimized
  updateStatTable(466.3, 362.2);
  var uploadNewBtn = document.getElementById('uploadNewBtn');
  if (uploadNewBtn) {
    uploadNewBtn.addEventListener('click', function() {
      document.getElementById('step2').style.display = 'none';
      document.getElementById('step1').style.display = '';
    });
  }
});
